<div class="notification-container" *ngIf="loading">
  <div class="text-center mt-5">
    <nz-spin nzSimple nzTip="Loading report details..."></nz-spin>
  </div>
</div>

<div
  class="notification-container drawer-view"
  *ngIf="!loading && reportDetails"
>
  <!-- 🔥 HEADER / PREVIEW -->
  <div class="notification-header">
    <div class="content">
      <h2 class="title">
        <app-mathjax [content]="getContentTitle()"></app-mathjax>
      </h2>

      <p class="description">
        <strong>Reported Reason:</strong>
        {{ reportDetails.reason || "No reason specified" }}
      </p>

      <div class="badges" style="margin-top: 10px">
        <nz-tag
          [nzColor]="
            reportDetails.status === 'pending'
              ? 'gold'
              : reportDetails.status === 'resolved'
                ? 'green'
                : 'red'
          "
        >
          {{ reportDetails.status | titlecase }}
        </nz-tag>

        <!-- Content Type Badge -->
        <nz-tag
          [nzColor]="
            reportDetails.question
              ? 'blue'
              : reportDetails.editorial
                ? 'purple'
                : reportDetails.currentAffair
                  ? 'orange'
                  : 'default'
          "
        >
          <i
            nz-icon
            [nzType]="
              reportDetails.question
                ? 'question-circle'
                : reportDetails.editorial
                  ? 'read'
                  : 'file-text'
            "
          ></i>
          &nbsp;{{ getContentType() | titlecase }}
        </nz-tag>
      </div>
    </div>
  </div>

  <!-- 🔥 TARGET CONTENT PREVIEW -->
  <div class="content-preview">
    <h3 class="preview-title">Target Content Preview</h3>
    <div class="preview-box">
      <!-- Question -->
      <ng-container *ngIf="reportDetails.question">
        <div class="q-text" *ngIf="reportDetails.question.questionText">
          <b>Q. </b
          ><app-mathjax
            [content]="reportDetails.question.questionText"
          ></app-mathjax>
        </div>
        <div class="q-options" *ngIf="reportDetails.question.options?.length">
          <div
            class="q-option"
            *ngFor="let item of reportDetails.question.options; let i = index"
          >
            <span>
              <b>{{ i + 1 }}. </b>
            </span>
            <app-mathjax
              [ngClass]="{ 'is-correct-ans': item.isCorrectOption }"
              [content]="item.optionText"
            ></app-mathjax>
          </div>
        </div>
      </ng-container>

      <!-- Current Affair or Editorial -->
      <ng-container
        *ngIf="reportDetails.currentAffair || reportDetails.editorial"
      >
        <div
          class="preview-image"
          *ngIf="
            reportDetails.currentAffair?.image ||
            reportDetails.editorial?.image ||
            reportDetails.editorial?.thumbnailImage
          "
        >
          <img
            [src]="
              imageBaseUrl +
              (reportDetails.currentAffair?.image ||
                reportDetails.editorial?.image ||
                reportDetails.editorial?.thumbnailImage)
            "
            alt="Content Image"
          />
        </div>
        <div class="preview-desc mt-3">
          <div
            [innerHTML]="
              reportDetails.currentAffair?.description ||
              reportDetails.editorial?.description
            "
          ></div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          !reportDetails.question &&
          !reportDetails.currentAffair &&
          !reportDetails.editorial
        "
      >
        <p class="text-muted">
          No additional rich content available to preview.
        </p>
      </ng-container>
    </div>
  </div>

  <!-- 🔥 DETAILS GRID -->
  <div class="info-grid">
    <!-- REPORTED BY -->
    <div class="info-card full" *ngIf="reportDetails.createdBy">
      <span nz-icon nzType="user"></span>
      <div>
        <label>Reported By</label>
        <p class="strong">
          {{ reportDetails.createdBy?.name || "Unknown User" }}
        </p>
        <p style="margin: 0; font-size: 13px; color: #666">
          {{ reportDetails.createdBy?.email }}
          <span *ngIf="reportDetails.createdBy?.mobile">
            | 📞 {{ reportDetails.createdBy?.mobile }}</span
          >
        </p>
      </div>
    </div>

    <!-- REPORTED ON -->
    <div class="info-card">
      <span nz-icon nzType="calendar"></span>
      <div>
        <label>Reported On</label>
        <p>
          {{ reportDetails.createdAt | date: "dd MMM yyyy, HH:mm" }}
        </p>
      </div>
    </div>

    <!-- TEST SERIES (Question only) -->
    <div
      class="info-card"
      *ngIf="reportDetails.question && reportDetails.testSeries"
    >
      <span nz-icon nzType="appstore"></span>
      <div>
        <label>Test Series</label>
        <p>{{ reportDetails.testSeries?.name || "—" }}</p>
      </div>
    </div>

    <!-- TEST NAME (Question only) -->
    <div class="info-card" *ngIf="reportDetails.question && reportDetails.test">
      <span nz-icon nzType="profile"></span>
      <div>
        <label>Test Name</label>
        <p>{{ reportDetails.test?.name || "—" }}</p>
      </div>
    </div>

    <!-- ADMIN NOTE -->
    <div class="info-card full" *ngIf="reportDetails.adminNote">
      <span nz-icon nzType="message"></span>
      <div>
        <label>Admin Note</label>
        <p>{{ reportDetails.adminNote }}</p>
      </div>
    </div>

    <!-- ACTIONED BY -->
    <div class="info-card full" *ngIf="reportDetails.statusChangedBy">
      <span nz-icon nzType="safety-certificate"></span>
      <div>
        <label>Actioned By Admin</label>
        <p class="strong">{{ reportDetails.statusChangedBy?.name }}</p>
        <p style="margin: 0; font-size: 13px">
          <nz-tag nzColor="geekblue">{{
            reportDetails.statusChangedBy?.role | titlecase
          }}</nz-tag>
        </p>
      </div>
    </div>
  </div>

  <div class="action-bar" style="margin-top: 30px; text-align: right">
    <button nz-button nzType="default" (click)="closeDrawer()">Close</button>
  </div>
</div>
